// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__QCmkf","spanLine":"navbar_spanLine__95N2u"};